import { LinkButton } from 'components/Global/LinkButton/LinkButton';
import TooltipDisclaimer from 'components/Global/Tooltip/Tooltip';
import { jsonDisclaimerLinkTester } from 'helpers/FormatText';
import React from 'react';
import { useStyles } from './TextRender.styles';

export interface ITextRenderProps {
  // TODO: handle undefined or null text
  text: string;
  tagName?: string;
  className?: string;
  tooltipBlurSafe?: boolean;
  linkValidation?: () => void;
  validateText?: boolean;
  showDisclaimerTitle?: boolean;
}
export const parseText = (label: string) => {
  return label
    .split(/\[\[|\]\]/)
    .map((item) => {
      try {
        return JSON.parse(item).disclaimer?.trigger;
      } catch {
        return item;
      }
    })
    .join('');
};

const TextRender = ({
  text,
  tagName,
  className,
  tooltipBlurSafe,
  linkValidation,
  showDisclaimerTitle,
  validateText,
}: ITextRenderProps): JSX.Element => {
  const classes = useStyles();

  const RenderTag = ({ tag, children, ...props }: any) =>
    React.createElement(tag, props, children);

  if (text && typeof text === 'string') {
    const processedString = text.split(/\[\[|\]\]/);

    const replaceText = (
      text: string,
      foundTexts: RegExpMatchArray | null,
      clean: boolean = false
    ) => {
      var processedText = text;
      if (foundTexts) {
        foundTexts.forEach(
          (element, index) =>
            (processedText = processedText.replace(
              clean ? element : `--reacttext${index}--`,
              clean ? `--reacttext${index}--` : element
            ))
        );
        return processedText;
      } else {
        return processedText;
      }
    };

    return (
      <RenderTag
        data-testid='textRender'
        tag={tagName || 'span'}
        className={
          `${classes.text_render} ${
            className?.includes('atm') ? '' : 'no-font'
          } ${className}` || ''
        }
      >
        {processedString.map((value: string, index: number) => {
          const foundText = value.match(/<a href=".*?>.*?<\/a>| ".*?" /g);
          const hasLinks = value.match(/<a href=".*?>.*?<\/a>/g);
          const cleanValue = (
            validateText ? replaceText(value, foundText, true) : value
          ).replace(/\n/g, '');
          if (jsonDisclaimerLinkTester(cleanValue)) {
            const foundObject = JSON.parse(cleanValue);
            const objectKey = Object.keys(foundObject)[0];
            switch (objectKey) {
              case 'disclaimer':
                return (
                  <TooltipDisclaimer
                    key={`Disc-${foundObject.disclaimer.content}`}
                    trigger={foundObject.disclaimer.trigger}
                    title={
                      showDisclaimerTitle
                        ? foundObject.disclaimer.title
                        : undefined
                    }
                    supportInLink={validateText}
                    ariaLabelDisclaimer={foundObject.disclaimer.ariaLabel}
                    information={
                      validateText
                        ? replaceText(foundObject.disclaimer.content, foundText)
                        : foundObject.disclaimer.content
                    }
                    white={foundObject.disclaimer.white}
                    isBlurSafe={tooltipBlurSafe || hasLinks !== null}
                  ></TooltipDisclaimer>
                );
              case 'link':
                return (
                  <LinkButton
                    key={`Link-${foundObject.link.label}`}
                    to={linkValidation ? null : foundObject.link.url}
                    onClick={() => {
                      linkValidation && linkValidation();
                    }}
                    isExternal={foundObject.link.isExternal ? true : false}
                    target={foundObject.link.target}
                    isDark={foundObject.link.isDark ? true : false}
                    classNames={{
                      container: classes.link_container,
                      link: classes.link_style,
                    }}
                  >
                    <TextRender text={foundObject.link.label} />
                  </LinkButton>
                );
              default:
                return <span />;
            }
          } else {
            return (
              <span
                key={`Text-${value}-${index}`}
                dangerouslySetInnerHTML={{ __html: value }}
              ></span>
            );
          }
        })}
      </RenderTag>
    );
  }
  return <></>;
};
export default TextRender;
